<template>
<div class="content alarmCensus" ref="tableBox" id="tableBox">
  <el-tabs class="tabLv3" type="border-card" v-model="tabName" :style="{

position: 'static'

}">
    <i class="lt"></i>
    <i class="rt"></i>
    <el-tab-pane name="jsgl">
      <span slot="label">
        <i class="iconfont iconcheck"></i>
        <i class="border"></i> 数据流统计
      </span>
      <div class="normalNav zaddBtn">
        <button class="BlueSmBtn" @click="search">搜索</button>
        <button class="OrangeSmBtn" @click="reset">重置</button>
        <!-- <button class="GreenSmBtn download" @click="download">导出</button> -->
      </div>
      <div class="searchForm1">
        <el-form ref="formData" :model="formData" :class="className" :rules="rules">
          <el-form-item label="设备编号" prop="deviceName" placeholder="请选择">
            <el-input v-model="formData.deviceName" @focus="deviceFocus"></el-input>
          </el-form-item>
          <el-form-item label="数据流" prop='dataflowFlag'>
            <el-select v-model="formData.dataflowFlag" placeholder="请选择">
              <el-option v-for="item in flowFlagArr" :key="item.data_flag" :label="item.name" :value="item.data_flag">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="统计间隔" prop="interval">
            <el-select v-model="formData.interval" placeholder="请选择" @change="bindData">
              <el-option v-for="item in dataArr" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" prop="beginTime">
            <el-date-picker v-model="formData.beginTime" :type="dataType" :value-format='valueFormat' placeholder="选择时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="endTime">
            <el-date-picker v-model="formData.endTime" :type="dataType" :value-format='valueFormat' placeholder="选择时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="展示类型">
            <el-select v-model="formData.chart" placeholder="请选择" @change="bindchart">
              <el-option v-for="item in chartArr" :key="item.name" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="统计方式" prop="type">
            <el-select v-model="formData.type" placeholder="请选择">
              <el-option v-for="item in statistics" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <template>
            <span class="collapseIcon" @click="className='expand'"><img v-default-img :src="require('public/searchForm/collapse.png')" alt=""></span>
            <!-- <span class="expandIcon" @click="className='collapse'"><img v-default-img :src="require('public/searchForm/expand.png')" alt=""></span> -->
          </template>
        </el-form>
      </div>
      <div class="detailtab nonedetailtab" v-if="showCont">
        <div>请搜索</div>
      </div>
      <div class="detailtab" v-if="!showCont">
        <div class="leftBar">
          <bar v-if='showBar' :chartData='chartData' :tableCalcul='tableCalcul' :flag='2'></bar>
          <line-chart v-if='showLine' :chartData='chartData' :tableCalcul='tableCalcul' :flag='2'></line-chart>
        </div>
        <div class="rightTable">
          <right-table :listData='listData' :items='items' :flag='2' :tableCalcul='tableCalcul'></right-table>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
  <div>
    <el-dialog class="editDialog dataTj" title="选择设备编号" :visible.sync="editDialogVisible" width="80%" :modal-append-to-body='false'>
      <device-list ref="deviceList"></device-list>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancelButton" @click="editDialogVisible = false">取消</el-button>
        <el-button class="confirmButton" type="primary" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</div>
</template>

<script>
import Qs from "qs";
export default {
  components: {
    normalNav: () => import("public/normalNav"),
    rightTable: () => import("./rightTable"),
    bar: () => import("./bar"),
    lineChart: () => import("./lineChart"),
    deviceList: () => import("./deviceList"),
  },
  data() {
    return {
      tabName: "jsgl",
      listData: [],
      changeDeviceArr: [],
      items: [{
          prop: "ts",
          label: "日期",
        },
        {
          prop: "amount",
          label: "数据值",
        },
      ],
      formData: {
        id: "",
        deviceName: "",
        dataflowFlag: "",
        interval: 1,
        endTime: "",
        beginTime: "",
        chart: "面积图",
        type: "",
      },
      rules: {
        id: [{
          required: true,
          message: "请选择设备编号",
          trigger: "change"
        }, ],
        dataflowFlag: [{
          required: true,
          message: "请选择数据流",
          trigger: "change",
        }, ],
        beginTime: [{
          required: true,
          message: "请选择开始时间",
          trigger: "change",
        }, ],
        endTime: [{
          required: true,
          message: "请选择结束时间",
          trigger: "change",
        }, ],
        type: [{
          required: true,
          message: "请选择统计方式",
          trigger: "change",
        }, ],
      },
      flowFlagArr: [],
      dataArr: [{
          name: "年",
          id: 3
        },
        {
          name: "月",
          id: 2
        },
        {
          name: "日",
          id: 1
        },
      ],
      statistics: [{
        name: "平均",
        id: 1
      }, {
        name: "求和",
        id: 2
      }, {
        name: "最大",
        id: 3
      }, {
        name: "最小",
        id: 4
      }],
      chartArr: [{
        name: "面积图"
      }, {
        name: "条形图"
      }],
      format: "yyyy 年 MM 月 dd 日",
      valueFormat: "yyyy-MM-dd",
      dataType: "date",
      className: "expand",
      showBar: false,
      showLine: false,
      chartData: {
        xData: [],
        seriesData: []
      },
      editDialogVisible: false,
      tableData: [],
      config: [{
          prop: "deviceName",
          label: "设备名称",
        },
        {
          prop: "device_mark",
          label: "设备编码",
        },
        {
          prop: "region",
          label: "所属区域",
        },
        {
          prop: "model",
          label: "设备型号",
        },
        {
          prop: "factory",
          label: "生产厂商",
        },
        {
          prop: "deviceStatusName",
          label: "设备状态",
        },
        {
          prop: "systemName",
          label: "应用系统",
        },
        {
          prop: "expire_time",
          label: "到期时间",
        },
      ],
      changeDeviceArr: [],
      showCont: true,
      tableCalcul: [],
    };
  },
  created() {},
  mounted() {
    this.getTableList();
  },
  methods: {
    bindchart() {
      if (this.formData.chart == "面积图") {
        this.showLine = true;
        this.showBar = false;
      } else {
        this.showLine = false;
        this.showBar = true;
      }
    },
    deviceFocus() {
      this.formData.dataflowFlag = "";
      this.editDialogVisible = true;
      this.$nextTick(_ => {
        this.$refs.deviceList.$refs.Table.toggleRowSelection(
          this.changeDeviceArr,
          true
        );
      });
    },
    getDataFlag(id) {
      this.$axiosget("manager/devicetype/dataflow?typeId=".concat(id)).then(
        res => {
          this.flowFlagArr = res.data.data;
        }
      );
    },
    confirm() {
      this.changeDeviceArr = this.$refs.deviceList.changeDevice;
      this.formData.id = this.$refs.deviceList.changeDevice.id;
      this.formData.deviceName = this.$refs.deviceList.changeDevice.deviceName;
      if (JSON.stringify(this.changeDeviceArr) == "{}") {
        this.$message.error("请选择设备");
      } else {
        this.getDataFlag(this.changeDeviceArr.deviceType);
        this.editDialogVisible = false;
      }
    },
    getTableList() {
      this.$axiosget("operation/device/list", {
        params: {
          pageSize: 10000,
          pageNum: 1
        },
      }).then(res => {
        this.tableData = res.data.data.deviceList;
      });
    },
    bindData() {
      let data = this.formData;
      if (data.interval == 1) {
        this.dataType = "date";
        data.beginTime = "";
        data.endTime = "";
        this.valueFormat = "yyyy-MM-dd";
      } else if (data.interval == 3) {
        this.dataType = "year";
        data.beginTime = "";
        data.endTime = "";
        this.valueFormat = "yyyy-MM-dd";
      } else {
        this.dataType = "month";
        data.beginTime = "";
        data.endTime = "";
        this.valueFormat = "yyyy-MM-dd";
      }
    },
    search() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          let data = this.formData;
          this.$axiosget("taos/taosdata/query_statistics", {
            params: {
              id: data.id,
              dataflowFlag: data.dataflowFlag,
              areaId: data.areaId,
              beginTime: data.beginTime+" 00:00:00",
              endTime: data.endTime+" 00:00:00",
              type: data.type,
              interval: data.interval,
            },
          }).then(res => {
            this.showCont = false;
            let Xdata = [],
              seriesdata = [];
            res.data.data.map(v => {
              Xdata.push(v.ts);
              seriesdata.push(v.amount-0);
            });
            let coumt;
            coumt = seriesdata.reduce(function (total, num) {
              return total + num;
            }, 0);
            let numberOne = isNaN(coumt / seriesdata.length) ?
              0 :
              coumt / seriesdata.length;
            // 总计和平均值
            this.tableCalcul = [coumt.toFixed(2), numberOne.toFixed(2)];
            this.listData = res.data.data;
            this.chartData = {
              xData: Xdata,
              seriesData: seriesdata
            };
            if (this.formData.chart == "面积图") {
              this.showLine = true;
              this.showBar = false;
            } else {
              this.showLine = false;
              this.showBar = true;
            }
          });
        }
      });
    },
    reset() {
      this.formData = {
        id: "",
        dataflowFlag: "",
        interval: 3,
        endTime: "",
        beginTime: "",
        chart: "面积图",
        type: "",
      };
      this.dataType = "date";
      this.valueFormat = "yyyy-MM-dd";
      this.$refs.formData.resetFields();
      this.showCont = true;
    },
    getData(data) {
      let list = [];
      this.chartData = {
        xData: [],
        seriesData: []
      };
      data.forEach(element => {
        element.deviceCountList.forEach(item => {
          list.push(item);
        });
      });
      list.forEach(el => {
        this.chartData.xData.push(el.typeName);
        // this.chartData.xData.push(el.typeName + " " + el.systemName);
        this.chartData.seriesData.push(el.amount);
      });
    },
    download() {},
    getSystem() {
      let data = this.formData;
      let p1 = this.$axiosget(
        "manager/operatingSystemApi/getOperatingSystemsByCompanyId?compayId=".concat(
          localStorage.getItem("companyId")
        )
      );
      let p2 = this.$axiosget("operation/dataCountApi/getCountCountList", {
        params: {
          id: data.id,
          interval: data.interval,
          dataflowFlag: data.dataflowFlag,
          areaId: data.areaId,
          beginTime: data.beginTime,
          endTime: data.endTime,
          type: data.type,
        },
      });
      Promise.all([p1, p2]).then(res => {
        let dataArr = JSON.parse(JSON.stringify(res));
        this.listData = dataArr[1].data.data;
        this.getData(this.listData);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.download {
  background: #6f67b9;
}

.boxs .alarmCensus {
  height: 100%;
  padding: 0 0 43px 0;
}

.detailtab {
  background-color: #181c2e;
  display: flex;
  width: 100%;
  height: calc(100% - 73px);
  padding-top: 20px;

  .rightTable {
    width: 520px;
    height: 100%;
    background-color: #232944;
  }

  .leftBar {
    flex: 1;
    position: relative;
    margin-right: 20px;
  }
}

.nonedetailtab {
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(181, 181, 181);
}
</style><style lang="less">
.alarmCensus .el-tabs,
.alarmCensus .el-tabs .content,
.alarmCensus .el-tabs .el-tabs__content .el-tab-pane {
  height: 100%;
}

.alarmCensus .el-tabs .el-tabs__content {
  height: calc(100% - 52px);
}

.alarmCensus .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
  display: none;
}

.box .alarmCensus {
  height: 100%;
  padding: 0 0 43px 0;
  /* background-color: #181c2e; */
}

.alarmCensus .el-form .el-form-item .el-form-item__content {
  width: calc(100% - 100px);

  .el-date-editor {
    width: calc(100%);
  }

  .el-range-input {
    background: #2e3657;
  }
}

.dataTj {
  thead .el-table-column--selection .cell {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute4/dataAnalysis/reportForms/dataStatistics.vue